module.exports = __webpack_public_path__ + "img/cool.7561b148.png";